/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TransferList = {
    type: 'array',
    contains: {
        type: 'Transfer',
    },
} as const;
